import { useAppDispatch, useAppSelector } from "store";
import { transpile } from "store/features";
import { SvgCaretRight } from "@itwin/itwinui-icons-react";
import { IconButton, ProgressRadial, Tooltip } from "@itwin/itwinui-react";
import styles from "./BuildButton.module.css";

export const BuildButton = () => {
  const status = useAppSelector((state) => state.transpiler.status);
  const itwinjsVersion = useAppSelector((state) => state.activeSandbox.itwinjsVersion);
  const dispatch = useAppDispatch();

  const onBuild = () => {
    dispatch(transpile());
  };

  if (status === "initializing" || status === "building")
    return (
      <div className={styles.spinner}>
        <ProgressRadial indeterminate size="small" />
      </div>
    )

  return (
    <Tooltip content={"Build and Run (Ctr+B)"} placement="bottom" delay={500} >
      <IconButton styleType="borderless" onClick={onBuild} disabled={itwinjsVersion === "2.x" || itwinjsVersion === "3.x"}>
        <SvgCaretRight className={styles.buildButton} />
      </IconButton>
    </Tooltip>
  )
}